(function () {
  'use strict';

  function init(tablist) {
    if (!tablist || tablist.dataset.gefTabsReady === 'true') return;
    tablist.dataset.gefTabsReady = 'true';

    var tabs = Array.prototype.slice.call(tablist.querySelectorAll('[role=tab]'));
    var panels = Array.prototype.slice.call(tablist.querySelectorAll('[role=tabpanel]'));
    var mobileMq = window.matchMedia ? window.matchMedia('(max-width: 767px)') : { matches: false };
    var reducedMotionMq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

    function isMobile() {
      return !!mobileMq.matches;
    }

    function scrollToPanel(panel) {
      if (!panel) return;
      function stickyOffset() {
        var stickyBottom = 0;
        document.querySelectorAll('.gef-cd-section--header, .gef-cd-header--sticky').forEach(function (header) {
          var style = window.getComputedStyle(header);
          if (style.position !== 'fixed' && style.position !== 'sticky') return;
          var rect = header.getBoundingClientRect();
          if (rect.top <= 1 && rect.bottom > 0) stickyBottom = Math.max(stickyBottom, rect.bottom);
        });
        return stickyBottom;
      }

      function correctCollapsedHeaderOffset() {
        if (!panel.isConnected) return;
        var desiredTop = stickyOffset() + 16;
        var delta = panel.getBoundingClientRect().top - desiredTop;
        if (Math.abs(delta) <= 2) return;
        var pageTop = window.pageYOffset || document.documentElement.scrollTop || 0;
        window.scrollTo({ top: Math.max(0, pageTop + delta), behavior: 'auto' });
      }

      window.requestAnimationFrame(function () {
        var pageTop = window.pageYOffset || document.documentElement.scrollTop || 0;
        var top = panel.getBoundingClientRect().top + pageTop - stickyOffset() - 16;
        window.scrollTo({ top: Math.max(0, top), behavior: reducedMotionMq.matches ? 'auto' : 'smooth' });

        if ('onscrollend' in window) {
          window.addEventListener('scrollend', correctCollapsedHeaderOffset, { once: true });
        }
        window.setTimeout(correctCollapsedHeaderOffset, reducedMotionMq.matches ? 50 : 700);
        window.setTimeout(correctCollapsedHeaderOffset, reducedMotionMq.matches ? 120 : 1300);
      });
    }

    function syncMode() {
      if (isMobile()) {
        panels.forEach(function (panel, index) {
          panel.hidden = false;
          panel.classList.add('is-active');
          var details = panel.querySelector('.gef-cd-tabs__acc-wrap');
          if (details) details.open = index === 0;
        });
        return;
      }
      var active = tabs.find(function (tab) { return tab.classList.contains('is-active'); }) || tabs[0];
      if (active) activate(active, false);
    }

    function activate(tab, shouldScroll) {
      var target = tab.getAttribute('data-tab-target');
      tabs.forEach(function (item) {
        var active = item === tab;
        item.setAttribute('aria-selected', active ? 'true' : 'false');
        item.setAttribute('tabindex', active ? '0' : '-1');
        item.classList.toggle('is-active', active);
      });
      panels.forEach(function (panel) {
        var active = panel.getAttribute('data-tab-panel') === target;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
        var details = panel.querySelector('.gef-cd-tabs__acc-wrap');
        if (details && !isMobile()) details.open = active;
      });
      if (shouldScroll) {
        var panel = tablist.querySelector('[data-tab-panel="' + target + '"]');
        scrollToPanel(panel);
      }
    }

    function activateTarget(target) {
      var targetTab = tabs.find(function (tab) {
        return tab.getAttribute('data-tab-target') === target;
      });
      if (!targetTab) return;
      if (isMobile()) {
        var panel = tablist.querySelector('[data-tab-panel="' + target + '"]');
        var details = panel && panel.querySelector('.gef-cd-tabs__acc-wrap');
        if (details) details.open = true;
        scrollToPanel(panel);
      } else {
        activate(targetTab, true);
      }
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () { activate(tab, false); });
      tab.addEventListener('keydown', function (event) {
        var nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = tabs.length - 1;
        else return;
        event.preventDefault();
        tabs[nextIndex].focus();
        activate(tabs[nextIndex], false);
      });
    });

    document.querySelectorAll('[data-tab-jump], a[href^="#panel-"]').forEach(function (button) {
      var href = button.getAttribute('href') || '';
      var linkedPanel = panels.find(function (panel) { return href === '#' + panel.id; });
      if (!linkedPanel || button.dataset.gefTabJumpReady === 'true') return;
      button.dataset.gefTabJumpReady = 'true';
      button.addEventListener('click', function (event) {
        event.preventDefault();
        activateTarget(linkedPanel.getAttribute('data-tab-panel'));
        if (window.location.hash !== href && window.history && window.history.pushState) {
          window.history.pushState(null, '', href);
        }
      });
    });

    document.querySelectorAll('[data-review-jump]').forEach(function (button) {
      if (button.dataset.gefReviewJumpReady === 'true') return;
      var href = button.getAttribute('href') || '#judgeme_product_reviews';
      var reviewTarget = document.getElementById(href.replace(/^#/, ''));
      if (!reviewTarget) return;
      button.dataset.gefReviewJumpReady = 'true';
      button.addEventListener('click', function (event) {
        event.preventDefault();
        scrollToPanel(reviewTarget);
        if (window.location.hash !== href && window.history && window.history.pushState) {
          window.history.pushState(null, '', href);
        }
      });
    });

    function activateHash() {
      var hash = window.location.hash;
      if (!hash) return;
      var linkedPanel = panels.find(function (panel) { return hash === '#' + panel.id; });
      if (linkedPanel) {
        activateTarget(linkedPanel.getAttribute('data-tab-panel'));
        return;
      }
      if (hash === '#judgeme_product_reviews') {
        var reviewTarget = document.getElementById('judgeme_product_reviews');
        if (reviewTarget) scrollToPanel(reviewTarget);
      }
    }

    if (mobileMq.addEventListener) mobileMq.addEventListener('change', syncMode);
    else if (mobileMq.addListener) mobileMq.addListener(syncMode);
    window.addEventListener('hashchange', activateHash);
    syncMode();
    if (window.location.hash) activateHash();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-gef-cd-tabs]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target || document);
  });
})();
